export class FiltroSelecionado {
    public propriedade: string;
    public condicao: string;
    public termo: string;
    public composicao: string;
}